import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Info(props) {
  return (
    <Svg
      width={props.size || 16}
      height={props.size || 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        d="M8.05 11.334a.485.485 0 00.5-.5V7.817a.453.453 0 00-.15-.342.494.494 0 00-.35-.141.486.486 0 00-.5.5v3.016c0 .133.05.247.15.342.1.094.217.142.35.142zM8 6.1c.156 0 .286-.05.392-.15a.505.505 0 00.158-.383.56.56 0 00-.158-.4A.519.519 0 008 5a.519.519 0 00-.391.167.56.56 0 00-.159.4c0 .155.053.283.159.383.105.1.236.15.391.15zm0 8.567c-.944 0-1.822-.17-2.633-.508A6.507 6.507 0 013.25 12.75c-.6-.6-1.07-1.305-1.408-2.117A6.762 6.762 0 011.333 8c0-.933.17-1.805.509-2.617A6.506 6.506 0 013.25 3.267c.6-.6 1.306-1.072 2.117-1.417A6.667 6.667 0 018 1.333c.934 0 1.806.173 2.617.517a6.618 6.618 0 012.116 1.417c.6.6 1.073 1.305 1.417 2.116.345.812.517 1.684.517 2.617 0 .945-.172 1.822-.517 2.633a6.62 6.62 0 01-1.417 2.117c-.6.6-1.305 1.07-2.116 1.409A6.718 6.718 0 018 14.666zm0-1c1.556 0 2.89-.556 4-1.667 1.111-1.11 1.667-2.444 1.667-4 0-1.555-.556-2.889-1.667-4-1.11-1.11-2.444-1.667-4-1.667-1.555 0-2.889.556-4 1.667-1.11 1.111-1.667 2.445-1.667 4 0 1.556.556 2.89 1.667 4 1.111 1.111 2.445 1.667 4 1.667z"
        fill={props.color || '#667085'}
      />
    </Svg>
  );
}

export default Info;
